import classNames from 'classnames';
import styles from './Kicker.module.scss';

export interface UI_KickerProps {
	className?: string;
	firstWord?: string;
	secondWord?: string;
}

export const UI_Kicker = ({ className, firstWord, secondWord }: UI_KickerProps) => {
	return (
		<div className={classNames(styles.Kicker, className)}>
			{firstWord && <span className={styles.Kicker_kickerFirst}>{firstWord}</span>}
			{secondWord && <span className={styles.Kicker_kickerSecond}>{secondWord}</span>}
		</div>
	);
};
